/* src/app/modules/institutions/institutions-public-note/institutions-public-note.component.scss */
/*# sourceMappingURL=institutions-public-note.component.css.map */
